<template>
  <div>
    <div class="row1">
		<div id="">
			<el-button
			  @click="onDel"
			  class="row-btn del"
			  style="width: 100px;margin-left: 0;"
			  type="primary"
			  size="small"
			  >删除</el-button
			>
			<el-button
			  @click="downLoad(0,1)"
			  class="row-btn add"
			  style="margin-left: 0;"
			  type="primary"
			  size="small"
			  >下载所有预留的点位表格</el-button
			>
		</div>
      <div class="dis-flex">
        <el-input
          size="small"
          clearable
          placeholder="搜索品牌名称"
          prefix-icon="el-icon-search"
          v-model="searchVal"
        >
        </el-input>
        <el-button
          @click="onSearch"
          class="row-btn add search"
          type="primary"
          size="small"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="tab-box">
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45"> </el-table-column>
        <el-table-column label="id序号" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
		<el-table-column prop="create_time" label="品牌名称"> 
			<template slot-scope="scope">{{ scope.row.report?scope.row.report.brand:'' }}</template>
		</el-table-column>
		<el-table-column prop="create_time" label="客户名称"> 
			<template slot-scope="scope">{{ scope.row.report?scope.row.report.name:'' }}</template>
		</el-table-column>
		<el-table-column prop="create_time" label="联系人"> 
			<template slot-scope="scope">{{ scope.row.report?scope.row.report.docking:'' }}</template>
		</el-table-column>
		<el-table-column prop="create_time" label="联系电话">
			<template slot-scope="scope">{{ scope.row.report?scope.row.report.phone:'' }}</template>
		</el-table-column>
		<el-table-column label="广告位">
			<template slot-scope="scope">
				<div v-for="(v,k) in scope.row.advertise_ids.length > 3 ? 3 : scope.row.advertise_ids.length" :key="k">
					{{scope.row.advertise_ids[k].name}}
				</div>
				<span @click="lookAll(scope.row.advertise_ids)" class="txt-btn mColor">查看更多</span>
			</template>
		</el-table-column>
		<el-table-column prop="create_time" width="200" label="预留时间"> 
			<template slot-scope="scope">{{ scope.row.start_time }}至{{ scope.row.end_time }}</template>
		</el-table-column>
		<el-table-column prop="expire_time" label="预留到期提醒">
			<template slot-scope="scope">{{ scope.row.expire_time }}</template>
		</el-table-column>
      <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
			  <div class="handle-box">
				  <span class="txt-btn txtC" @click="yancang(scope.row.id)">延长预留</span>
				  <span class="txt-btn txtC" @click="downLoad(scope.row.id)">下载基础信息</span>
			  </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<!-- 查看更多弹框 -->
	<offer-more :tableData="moreTabData" ref="moreDialog"></offer-more>
  </div>
</template>

<script>
	import offerMore from "../../components/dialog/order/offer.vue";
export default {
	components: {
	  offerMore,
	},
  data() {
    return {
		moreTabData:[],
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
	  this.id = this.$route.query.id;
    this.getList();
  },
  methods: {
	  yancang(id){
		  this.loading = true;
		  this.$api2.reserveDelay({id:id}).then((res)=>{
			  this.loading = false;
			  if(res.code == 1){
			  	this.$message.success(res.msg)
			  }else{
			  	this.$message.error(res.msg)
			  }
		  }).catch(err => {
			this.loading = false;
		  });
	  },
	  downLoad(id,type = 0){
		  let sesion = this.getCookie('PHPSESSID');
		  if(type == 1){
			window.open(this.$baseUrl + '/admin/Reserve/downloadAllBasis' + `?PHPSESSID=${sesion}`);
		  }else{
			window.open(this.$baseUrl + '/admin/reserve/downloadBasis' + `?id=${id}&PHPSESSID=${sesion}`);
		  }
	  },
	  // 获取cookie
	  getCookie(name) {
	   var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	   if (arr = document.cookie.match(reg))
	    return (arr[2]);
	   else
	    return null;
	  },
	  //多选删除
	  onDel() {
	    if (!this.multipleSelection.length) return this.$message.error("请勾选要删除的选项！");
	    let ids = []
	    this.multipleSelection.forEach((v,k)=>{
	    	ids[k] = v.id
	    })
	    this.$confirm('确认删除？', '提示').then(() => {
	    	this.$api2.reserveDelete({id:ids}).then((res)=>{
	    		if(res.code == 1){
	    			this.$message.success(res.msg)
	    			this.getList()
	    		}else{
	    			this.$message.error(res.msg)
	    		}
	    	})
	    }).catch(()=>{})
	    
	  },
	  //查看全部
	  lookAll(item){
		  this.moreTabData = item;
		  this.$refs.moreDialog.dialogVisible = true;
	  },
    //搜索
    onSearch(){
		this.pageObj.page = 1
		this.pageObj.filter.brand = this.searchVal;
		this.pageObj.op.brand = '='
		this.getList()
    },
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.reserveList(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
			//审批，关联信息跳转过来筛选数据
			if(this.id){
				this.total = 1
				res.data.forEach((v,k)=>{
					if(v.id == this.id){
						this.tableData = [v]
					}
				})
			}else{
				this.total = res.count;
				this.tableData = res.data;
			}
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-around;
}
</style>